import { CONTENTFUL_VIDEO_BASE_URL } from "./constants";

export function getContentfulVideoUrl(url: string) {
  return url.replace("https://videos.ctfassets.net", CONTENTFUL_VIDEO_BASE_URL);
}
